import { Pipe, PipeTransform } from '@angular/core';
import { RoleEnum } from '../enums';
import { enums } from '../classes';
@Pipe({
    name: 'RoleFilter'
})
export class RolePipe implements PipeTransform {

    transform(value: RoleEnum, arg: string): any {
        // const filters = ['of', 'and', 'or'];
        // console.log('CapitalizePipe', value.split(' '));
        // value.split(' ').forEach(s => {
        //   console.log('CapitalizePipe', s);
        //   if (!filters.find(x => x.toUpperCase() === s.toUpperCase())) {

        //    s.charAt(0).toUpperCase();
        //     console.log('Capitalized', s);
        //   }
        // });
        // console.log('CapitalizePipe', value);
        if (value === undefined) {
            return '--';
        } else {
            return enums.RoleToString(value);
        }
    }
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/pipes/role.pipe.ts